import React, { Component } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class DateRange extends Component {

  constructor(props) {
    super(props);
    this.state = {
      chosenLabel: props.defaultChosenLabel || null,
      startDate: props.startDate,
      endDate: props.endDate
    };
  }

  handleApply(e, p) {
    this.setState({
      ...this.state,
      chosenLabel: p.chosenLabel,
      startDate: p.startDate,
      endDate: p.endDate
    }, () => {
      this.props.onApply(this.state);
    });
  }

  render() {
    const { startDate, endDate } = this.state;
  
    return (
      <DateRangePicker
        opens={this.props.opens || 'right'}
        startDate={startDate}
        endDate={endDate}
        ranges={this.props.ranges}
        onApply={this.handleApply.bind(this)}
      >
        <div
          id='reportrange'
          className='pull-left'
          style={this.props.disabled ? {
            pointerEvents: 'none',
            filter: 'opacity(0.5)'
          } : {}}
        >
          <FontAwesomeIcon icon='calendar-alt' /> &nbsp;
            <span>{this.state.chosenLabel}</span> &nbsp;
            <b className='caret' />
        </div>
      </DateRangePicker>
    );
  }
}

export default DateRange;
